export const TEST_ID = 'cardText';
